import { BaseError } from '../../../errors/base.js';

class AmountMismatchError extends BaseError {
    constructor(requested, remaining) {
        super("Unable to fulfill requested amount", {
            details: `Unable to fulfill requested amount ${requested.amount} (decimals: ${requested.decimals}) with remaining amount ${remaining.amount} (decimals: ${remaining.decimals})`,
        });
        this.name = "AmountMismatchError";
    }
}

export { AmountMismatchError };
//# sourceMappingURL=amountMismatchError.js.map
